<template>
    <tr>
        <td v-if="!editMode">{{data.name}}</td>
        <td v-else>
            <v-text-field
                hide-details
                outlined
                dense
                v-model="row.name"
            >
            </v-text-field>
        </td>
        <v-spacer></v-spacer>
        <td align="end"> 
            <v-btn icon v-if="editMode" @click="handelSave" :loading="waitEdit" ><v-icon>mdi-content-save</v-icon></v-btn>
            <v-btn icon @click="handelDelete()" :loading="howLoading"><v-icon>mdi-delete</v-icon></v-btn>
            <v-btn icon @click="handelEdit" :disabled="penDisable" :title="$t('edit')"><v-icon>mdi-pencil</v-icon></v-btn>
        </td>
        <MalfactionNotification :text="snackbar.text" :value.sync="snackbar.visible"/>
        
    </tr>
</template>

<script>
import {editMalfaction} from '../services/malfactions'
import MalfactionNotification from './MalfactionNotification.vue'
export default {
    name: "FailureTableRow",
    components:{
        MalfactionNotification
    },
    props: {
        data: Object,
        deleteLoading: Number
    },
    data() {
        return {
            editMode: false,
            penDisable: false,
            snackbar: {
                text: '',
                visible: false,
            },
            waitEdit: false,
            howLoading: false,
            errors: []
        }
    },
    computed: {
        row() {
            return {...this.data}
        }
    },
    methods: {
        handelEdit() {
            this.editMode = !this.editMode
        },
        async handelSave() {
            this.clearErrors() 
            this.waitEdit = !this.waitEdit
            this.penDisable = true
            let response = null

            try {
                response = await editMalfaction(this.row.id, this.row)
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.setErrors(message)
                }

            this.$emit('editRecord', response.data.record)
            this.waitEdit = !this.waitEdit
            this.editMode = false
            this.penDisable = false

            this.snackbar = {
                visible : !this.editNotification,
                text : this.$t('EDIT_SUCCESS')
            }
            

        },
        setErrors(message) {
            this.errors.push(message)
        },
        clearErrors() {
            this.errors.splice(0, this.errors.length - 1)
        },
        handelDelete() {
            this.howLoading = true
            this.$emit('delete', this.row.id)

        }
    },
    watch: {
        deleteLoading : {
            handler(val) {
                this.howLoading = !val
            },
            deep: true
        }
    }

}
</script>

<style>

</style>